module.exports = __webpack_public_path__ + "static/img/px2.6f111ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/px2.png
// module id = GMlk
// module chunks = 2